<template>
  <div class="m-exhibition-list">
    <div class="visually-hidden hidden-media-print-visible">
      <h3>
        {{ printHeading }}
      </h3>
      <h4 id="exhibition-list-aria">
        {{ ariaHeading }}
      </h4>
      <br />
    </div>
    <ul class="m-exhibition-list__list" aria-labelledby="exhibition-list-aria">
      <ExhibitionItem
        v-for="(exhibition, key) in exhibitions"
        :key="key"
        v-bind="exhibition"
      />
    </ul>
  </div>
</template>

<script>
import { useLocalization } from "@thegetty-private/getty-ui";
import ExhibitionItem from "@/components/atoms/exhibitionItem/index.vue";

export default {
  name: "ExhibitionList",
  components: {
    ExhibitionItem
  },

  props: {
    /**
     * The Exhibition Data from the store
     */
    exhibitions: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * The ARIA heading for the exhibition list data
       */
      ariaHeading: this.translatePart("exhibition_list.ariaHeading"),
      /**
       * The heading displayed on just the print style sheet
       */
      printHeading: this.translatePart(
        "human_made_object_tabs.exhibitionsTabName"
      )
    };
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
